module.exports = __webpack_public_path__ + "img/us.936feee6.svg";